import { Button, Dialog, DialogActions, Box, DialogContent, OutlinedInput, IconButton, DialogTitle, Typography, FormHelperText, Divider } from '@mui/material';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useState, useCallback } from 'react';
import Iconify from '../../Iconify';
import axios from 'axios';
import * as Yup from 'yup';
import '../../../css/machines/DuplicateMachineDialoge.css';

export const DuplicateMachineDialoge = ({ defaultName, openDuplicateMachine, setOpenDuplicateMachine }) => {

    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();

    const [machineName, setMachineName] = useState(defaultName);

    const validationMachineData = Yup.object().shape({
        machineName: Yup.string().trim().required(),
    })

    const checkValidation = validationMachineData.isValidSync({
        machineName: machineName,
    })

    const handleClose = useCallback(() => {
        setOpenDuplicateMachine(false);
    }, [setOpenDuplicateMachine]);

    const handleDuplicateMachine = useCallback(async () => {
        try {
            if (!checkValidation) return;

            const response = await axios.post(`machine/duplicate/${id}`, { name: machineName });
            if (response.status === 200 || response.status === 201) {
                setOpenDuplicateMachine(false);
                navigate(`/dashboard/machines/machine_details/${response.data.id}`);
            }
        } catch (error) {
            CustomErrorLogger(error, 'Error duplicate machine in DuplicateMachineDialoge');
            console.error('Error duplicate machine in DuplicateMachineDialoge', error);
        }
    }, [checkValidation, id, machineName, navigate, setOpenDuplicateMachine]);

    return (
        <Dialog open={openDuplicateMachine} maxWidth='md'>
            <IconButton onClick={handleClose} className='duplicateMachine_icon_button'>
                <Iconify icon={"material-symbols:close"} className='duplicateMachine_close_icon' />
            </IconButton>
            <DialogTitle className='duplicateMachine_dialog_title'>{t('duplicateMachineDialogTitle')}</DialogTitle>
            <Divider />
            <DialogContent className='duplicateMachine_dialog_content'>
                <Typography className='duplicateMachine_dialog_SubTitle'>{t('duplicateMachineDialogSubtitle')}</Typography>
                <Box sx={{ mt: 5 }}>
                    <FormHelperText id="outlined-weight-helper-text" className="duplicateMachineInputTitle">{t('duplicateMachineInputLabel')}</FormHelperText>
                    <OutlinedInput
                        fullWidth
                        value={machineName}
                        className={`duplicateMachine_InputField ${machineName ? 'duplicateMachineFilled' : ''}`}
                        id="outlined-adornment-weight"
                        onChange={(e) => setMachineName(e.target.value)}
                        aria-describedby="outlined-weight-helper-text"
                    />
                </Box>
            </DialogContent>
            <DialogActions className='duplicateMachine_dialog_actions'>
                <Button className='duplicateMachine_button_annuler' onClick={handleClose}>{t('Annuler')}</Button>
                <Button className='duplicateMachine_button_valider' variant="contained" onClick={handleDuplicateMachine}>{t('Valider')}</Button>
            </DialogActions>
        </Dialog>
    );
};
